import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=e764e41a&lang=pug"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"
import style0 from "./Modal.vue?vue&type=style&index=0&id=e764e41a&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e764e41a')) {
      api.createRecord('e764e41a', component.options)
    } else {
      api.reload('e764e41a', component.options)
    }
    module.hot.accept("./Modal.vue?vue&type=template&id=e764e41a&lang=pug", function () {
      api.rerender('e764e41a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/basic/Modal.vue"
export default component.exports